import { EllipsisSpan } from '@maxtropy/components';
import { ColumnType } from 'antd/es/table';
import { OutsiderResponse } from '../../api/deviceAlarmPushStrategy';
import { SaleClientContactInfo } from '../../api/sale';

export const columns: ColumnType<OutsiderResponse>[] = [
  {
    title: '联系人',
    dataIndex: 'contactName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '手机号',
    dataIndex: 'contactPhone',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

export const contactColumns: ColumnType<SaleClientContactInfo>[] = [
  {
    title: '联系人',
    dataIndex: 'contactName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '手机号',
    dataIndex: 'contactCellphone',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '备注',
    dataIndex: 'description',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];
